import React from 'react'
import OrderManagementLayout from 'presentation/hospital/layouts/OrderManagement'

export default function OrderManagement() {
  return <OrderManagementLayout />
}
